import React, { useState } from "react";
import { ColorModeContext, useMode } from "./assets/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Topbar from "./layouts/Topbar";
import AppRoutes from "./AppRoutes";
import Sidebar from "./layouts/Sidebar";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
} from "@azure/msal-react";
import RequestInterceptor from "./auth/RequestInterceptor";
import {
    QueryClient,
    QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { IntlProvider } from 'react-intl';
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import AuthProvider from "./auth/authProvider.jsx";
import { initMuiXLicense } from "./initMuiLicense";
import LoginGate from "./auth/LoginGate";

initMuiXLicense();

const queryClient = new QueryClient({});
function App() {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const { instance } = useMsal();
    const [isCollapsed, setIsCollapsed] = useState(false);

    const defaultLocale = useSelector((state) => state.language.language);
    const messages = require(`./translations/${defaultLocale}.json`) // en.json 
    const locale = defaultLocale

    return (
        <IntlProvider locale={locale} messages={messages}>
            <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <RequestInterceptor>
                        <AuthenticatedTemplate>
                            <AuthProvider msalInstance={instance}>
                                <QueryClientProvider client={queryClient}>
                                    <div className="app">
                                        <Sidebar isSidebar={isSidebar} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                                        <ToastContainer />
                                        <main className="content">
                                            <Topbar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                                            <Routes>
                                                {AppRoutes.map((route, index) => {
                                                    const { element, ...rest } = route;
                                                    return <Route key={index} {...rest} element={element} />;
                                                })}
                                            </Routes>
                                        </main>
                                    </div>
                                    <ReactQueryDevtools initialIsOpen={false} />
                                </QueryClientProvider>
                            </AuthProvider>
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <LoginGate />
                        </UnauthenticatedTemplate>
                    </RequestInterceptor>
                </ThemeProvider>
            </ColorModeContext.Provider>
        </IntlProvider>
    );
}

export default App;
